<script setup lang="ts">
import CoreMaintenanceGate from '#core/components/Core/CoreMaintenanceGate.vue'
import CoreMobileGate from '#core/components/Core/CoreMobileGate.vue'
import { Sonner } from '@forgd/ui-kit/sonner'
import { TooltipProvider } from '@forgd/ui-kit/tooltip'
import { useColorMode } from '@vueuse/core'

const colorMode = useColorMode()
colorMode.value = 'light'

useHead({
  titleTemplate: title => title ? `${title} · Forgd` : 'Forgd',
})
</script>

<template>
  <TooltipProvider disable-hoverable-content>
    <div>
      <CoreMaintenanceGate>
        <NuxtLayout>
          <NuxtPage />
        </NuxtLayout>
      </CoreMaintenanceGate>
      <ClientOnly>
        <CoreMobileGate />
        <CoreCookieConsentBanner />
        <Sonner />
      </ClientOnly>
    </div>
  </TooltipProvider>
</template>

<style>
@reference "@forgd/ui-kit/styles/tailwind.css";

.balanced {
  text-wrap: balance
}

.balanced a {
  @apply text-accent font-semibold;
}
</style>
